// Kept free of app imports: the Apollo link chain uses it.
import { ApolloError } from '@apollo/client'

// Error codes aren't sent, so strip the transport and class-name prefixes the
// backend may add, without touching unrelated messages.
const KNOWN_PREFIXES =
  /^(?:Bad request:\s*|(?:[\w$]+\.)*HiddenInWaveWouldBreakDependencyError:\s*)+/

const cleanMessage = (message: string): string =>
  message.trim().replace(KNOWN_PREFIXES, '').trim()

export const waveVisibilityErrorMessage = (error: unknown): string => {
  const messages =
    error instanceof ApolloError && error.graphQLErrors.length > 0
      ? error.graphQLErrors.map(({ message }) => message)
      : [error instanceof Error ? error.message : '']
  // Snackbars collapse newlines, and each backend message is a full sentence.
  const message = messages.map(cleanMessage).filter(Boolean).join(' ')
  return message || 'Could not update wave visibility. Please try again.'
}

const DEPENDENCY_REJECTION =
  /^Cannot save this change: .+ is hidden in this wave but /

/** The readable text of a hidden-in-wave dependency rejection, or undefined for any other error. */
export const hiddenInWaveRejectionMessage = (
  message: string
): string | undefined => {
  const cleaned = cleanMessage(message)
  return DEPENDENCY_REJECTION.test(cleaned) ? cleaned : undefined
}
